import React from 'react';
import { CardActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Container, PageHeader, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { Button, Typography, Divider, Card, CardContent } from '@occc/ui-design-system';

import { breadcrumbLinks } from './constants';

import { FormContent } from '../components/FormContent';
import { ProductCategoryFormRenderProps } from '../types';

export interface CreateProductCategoryFormRenderComponentProps
  extends Pick<ProductCategoryFormRenderProps, 'handleSubmit'> {
  disabled: boolean;
}

export const CreateProductCategoryFormRenderComponent: React.FC<
  CreateProductCategoryFormRenderComponentProps
> = ({ handleSubmit, disabled }) => {
  const navigate = useNavigate();

  useAppLayoutContextConsumer(breadcrumbLinks);

  // TODO: move Container and PageHeader to level up and replace it along with Helmet by Page component
  return (
    <Container variant='md' includesPageHeader>
      <PageHeader
        title='Product Preference'
        subtitle='Product Preferences that your members can express interest in.'
      />
      <form onSubmit={handleSubmit}>
        <Card>
          <CardContent>
            <Typography variant='h6' gutterBottom>
              Create Product Preference
            </Typography>
            <FormContent />
          </CardContent>
          <Divider />
          <CardActions>
            <Button onClick={() => navigate(-1)}>Cancel</Button>
            <Button variant='contained' color='primary' onClick={handleSubmit} disabled={disabled}>
              Create
            </Button>
          </CardActions>
        </Card>
      </form>
    </Container>
  );
};
